// Reviewed generic tutorials. Keep unavailable videos out of the published catalog.
export const videoGuides = [
  {
    "id": "prompt",
    "youtubeId": "BRWMXkpMDB0",
    "title": "Edit and test your AI prompt",
    "description": "Use version history, the editing assistant and real conversation tests.",
    "duration": "4:19",
    "category": "AI Agent",
    "embed": "https://www.youtube-nocookie.com/embed/BRWMXkpMDB0?rel=0"
  },
  {
    "id": "phone-numbers",
    "youtubeId": "UqDI1gh8Hzs",
    "title": "Assign AI phone numbers",
    "description": "Choose an area code and source, then add numbers to your agent.",
    "duration": "1:15",
    "category": "AI Agent",
    "embed": "https://www.youtube-nocookie.com/embed/UqDI1gh8Hzs?rel=0"
  },
  {
    "id": "sources",
    "youtubeId": "VXFnREh3BC0",
    "title": "Track leads by source",
    "description": "Use separate numbers for LSA, Google Business Profile, Yelp and your website.",
    "duration": "3:04",
    "category": "Lead management",
    "embed": "https://www.youtube-nocookie.com/embed/VXFnREh3BC0?rel=0"
  },
  {
    "id": "recording",
    "youtubeId": "Jtg6v2-ztq4",
    "title": "Set up recording notifications",
    "description": "Enable a recording notice and customize how it works with your call flow.",
    "duration": "0:58",
    "category": "AI Agent",
    "embed": "https://www.youtube-nocookie.com/embed/Jtg6v2-ztq4?rel=0"
  },
  {
    "id": "qualification",
    "youtubeId": "HASwDyB1SNQ",
    "title": "Define high-value leads",
    "description": "Set qualification rules, correct lead ratings and re-evaluate existing leads.",
    "duration": "3:45",
    "category": "Lead management",
    "embed": "https://www.youtube-nocookie.com/embed/HASwDyB1SNQ?rel=0"
  },
  {
    "id": "lead-status",
    "youtubeId": "SnP6_Meei6g",
    "title": "Update lead status and qualifications",
    "description": "Mark leads In Contact and update qualifications from the report.",
    "duration": "1:02",
    "category": "Lead management",
    "embed": "https://www.youtube-nocookie.com/embed/SnP6_Meei6g?rel=0"
  },
  {
    "id": "referrals",
    "youtubeId": "T8OvZFMjDMg",
    "title": "Use Refer & Earn",
    "description": "Find your referral link and track commissions, referrals and payouts.",
    "duration": "1:53",
    "category": "Agency",
    "embed": "https://www.youtube-nocookie.com/embed/T8OvZFMjDMg?rel=0"
  }
];

export const legacyGuides = [
  {
    "id": "legacy-0",
    "title": "Setup Guide",
    "description": "Exploring the DIY AI Platform: A Quick Setup Guide",
    "embed": "https://www.loom.com/embed/5b3d2ad5e2b044c59d866617ef4e273b",
    "category": "More tutorials",
    "diyOnly": true
  },
  {
    "id": "legacy-1",
    "title": "How to Login to the LSA Dashboard",
    "description": "In this quick video, I'll show you how to login to our LSA Software.",
    "embed": "https://www.loom.com/embed/b8311b762789482da31bffb279fece42",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-2",
    "title": "Where to find the calls and text answered by AI",
    "description": "In this quick video, I'll show you how to locate your calls and message leads in the app's back office.",
    "embed": "https://www.loom.com/embed/960024a811a34c7ab786501e7d55128a",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-3",
    "title": "How to find your or get your username and password?",
    "description": "This video is helpful if you ever lose your username or forgot your password.",
    "embed": "https://www.loom.com/embed/82898bae9b76468384d165164576a596",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-4",
    "title": "How to set up notifications in our software?",
    "description": "Learn how to configure email and SMS notifications to receive important updates from the app.",
    "embed": "https://www.youtube.com/embed/a_hjRKaUUoI?si=UG3e6w1dJMjsTF6w",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-5",
    "title": "What is A2P compliance for text?",
    "description": "A2P gives you the ability to send SMS messages to your clients. Learn more about it in the video below.",
    "embed": "https://www.loom.com/embed/6d25712fa31b464f97042ec6542dbaa4",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-6",
    "title": "How to fill in your A2P form?",
    "description": "Learn how to fill in your A2P in the video below.",
    "embed": "https://www.loom.com/embed/42a23bf5ab5f4682b7657b0beb60b397",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-7",
    "title": "How to edit your prompt in our software?",
    "description": "In this video, I show you how to edit your text and voice prompt in our software and how to see how the prompt behaves.",
    "embed": "https://www.loom.com/embed/942915ba95a3400f91b9c2ae6b81f75c",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-8",
    "title": "What is a prompt?",
    "description": "In this video I give you insights on what a prompt is and where to find it in our software.",
    "embed": "https://www.loom.com/embed/6793c2de33cf41acb945a0dc9eb159ab",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-9",
    "title": "How to create a LSA Audit?",
    "description": "What the video below to learn how to create a LSA Audit in our software.",
    "embed": "https://www.loom.com/embed/dd02441a36f745dd91234ab67057c8bf",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-10",
    "title": "How to generate service areas with our tool?",
    "description": "Step-by-step guide to mapping service areas and easily define service zones in seconds.",
    "embed": "https://www.loom.com/embed/2360495b90164489acf90cfab71bf92d",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-11",
    "title": "How Rate Your LSA Leads Instantly & Track Feedback",
    "description": "Our software lets you rate your LSA leads instantly, even those under review, and keeps a full record of your feedback.",
    "embed": "https://www.youtube.com/embed/xR0UMenrzks?si=4bd8o3MhXafYt-6N",
    "category": "More tutorials",
    "diyOnly": false
  },
  {
    "id": "legacy-12",
    "title": "Auto-Tag Leads",
    "description": "Setup triggers to automate specific actions like email notifications or auto-tagging of the leads.",
    "embed": "https://www.loom.com/embed/ccbe8ab024f344b5bf3d8baf4a81217c",
    "category": "More tutorials",
    "diyOnly": false
  }
];
